import { get, post } from "../httpInterceptor";

// Update Password
export const updatePassword = (data) => {
  return post(`/authentication/updatePassword`, data).then((res) => {
    console.log("RESPONSE :: Update Password ::: ", res);
    return res;
  });
};
